import { Icon, IconName } from '@openeducation/oe-rn-components';
import React from 'react';
import {
  StyleProp,
  StyleSheet,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import { ActivityIndicator } from 'react-native-paper';

import styles from './button.style';
import { useColors, useFont } from '../../hooks/lesson-player.context';
import { mediaQueryValues } from '../media-query';
import { ThemedText } from '../themed-text';
import { roundedButton } from '../view-style';

export interface ButtonProps {
  containerStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  children: any;
  activeOpacity?: number;
  backgroundColor?: string;
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
  iconLeft?: IconName;
  iconRight?: IconName;
}

export function Button({
  children,
  onPress,
  containerStyle,
  textStyle,
  activeOpacity = 0.6,
  backgroundColor,
  disabled = false,
  loading = false,
  iconLeft,
  iconRight,
}: ButtonProps) {
  const colors = useColors();
  const font = useFont();
  const mediaQuery = mediaQueryValues();

  const activityIndicatorSize =
    StyleSheet.flatten(textStyle)?.fontSize || 'small';

  return (
    <TouchableOpacity
      activeOpacity={activeOpacity}
      onPress={onPress}
      disabled={disabled}
    >
      <View
        style={[
          styles.container,
          {
            backgroundColor: backgroundColor || colors.primary,
            ...roundedButton,
          },
          disabled && { backgroundColor: colors.darkGray },
          containerStyle,
        ]}
      >
        {loading && (
          <ActivityIndicator
            color={colors.onPrimary}
            style={styles.loadingIndicator}
            size={activityIndicatorSize}
          />
        )}
        {iconLeft && (
          <Icon
            type="solid"
            name={iconLeft}
            size={mediaQuery.small}
            color={colors['onPrimary']}
            style={[styles.leftIcon, textStyle]}
          />
        )}
        {Array.isArray(children) ? (
          children?.map((c, i) => (
            <ThemedText
              style={[font.primary.bold, textStyle]}
              key={i}
              type="onPrimary"
              fontType="primary"
              fontSize="small"
            >
              {c}
            </ThemedText>
          ))
        ) : (
          <ThemedText
            type="onPrimary"
            fontSize="small"
            style={[font.primary.bold, textStyle]}
          >
            {children}
          </ThemedText>
        )}
        {iconRight && (
          <Icon
            type="solid"
            name={iconRight}
            size={mediaQuery.small}
            color={colors['onPrimary']}
            style={[styles.rightIcon, textStyle]}
          />
        )}
      </View>
    </TouchableOpacity>
  );
}
